import { defer } from "lib/defer"

export const authCompleted = defer()

export function notiftyAuthInitialized() {
    authCompleted.resolve(true)
}
